import ArticleStore from 'ui-article/axel-publication-content/js/ArticleStore';

export default class CabiArticleStore extends ArticleStore {
    constructor(config, processors = {}, options = {}) {
        super(config, processors, options);
    }

    defaultProcessorTitleCustom(obj, title, type) {
        if (!title && type === 'tables') {
            const parentWidget = obj.closest('.cabi-widget');
            title = parentWidget?.parentNode?.querySelector('h2');
        }
        return title;
    }

    _processData() {
        const data = super._processData();
        const seen = new Set();
        data.figures.media = data.figures.media.filter(item => {
            if (seen.has(item.content)) {
                return false;
            }
            seen.add(item.content);
            return true;
        });
        return data;
    }
}
